var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"admin-processes margin__md"},[_c('HeroSmall',{attrs:{"links":_vm.links,"calls":_vm.calls,"imgs":_vm.imgs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }